import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconGoToFilled({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M11 6A5 5 0 1 1 1 6a5 5 0 0 1 10 0zM3 6a.5.5 0 0 1 .5-.5h3.793l-.56-.56a.5.5 0 0 1 .706-.708l1.415 1.414a.5.5 0 0 1 0 .708L7.439 7.768a.5.5 0 0 1-.707-.707l.561-.561H3.5A.5.5 0 0 1 3 6z"/>
        </svg>
    );
}

export default IconGoToFilled;
